/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResultCode } from '../../models/result-code';

export interface ResultCodes$Params {
}

export function resultCodes(http: HttpClient, rootUrl: string, params?: ResultCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResultCode>>> {
  const rb = new RequestBuilder(rootUrl, resultCodes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResultCode>>;
    })
  );
}

resultCodes.PATH = '/resultcodes';
